import { AxiosResponse, AxiosError } from "axios";

import { RESERVE_API_ENDPOINTS } from "@/features/reserves/api/endpointsReserve";
import { ReserveBaseModel } from "@/features/reserves/types/reserveModels";
import apiRequests from "@/shared/config/axiosConfig";

export default async function addReserve(
  reserve: ReserveBaseModel
): Promise<ReserveBaseModel> {
  try {
    const url = RESERVE_API_ENDPOINTS.CREATE_RESERVE;
    const response: AxiosResponse<ReserveBaseModel> = await apiRequests.post(
      url,
      reserve
    );
    const { data, status } = response;

    if (status >= 200 && status < 300) {
      return data;
    }

    throw new Error(`Unknown error occurred with status code ${response.status}`);
  } catch (e) {
    // @todo Handle Error Below
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
